<template>
	<Col>
		<NavigationAccordion
			:key="i"
			:to="item.to"
			:title="item.title"
			:sections="item.sections"
			:settings="item.settings"
			:class="{ 'mt-4': i !== 0 }"
			v-for="(item, i) in accordionsList"
			:createNewConfig="item.createNewConfig"
			:titleSuffixComponent="item.titleSuffixComponent"
			:additionalItemSuffix="item.additionalItemSuffix"
			:collapsedModeNavButtonItem="item.collapsedModeNavButtonItem"
		/>
	</Col>
</template>
<script>
import NavigationAccordion from './NavigationAccordion.vue';
export default { name: 'NavigationAccordionsList', components: { NavigationAccordion }, props: { accordionsList: { type: Array } } };
</script>
